import {
	useInteractions as useFloatingUiInteractions,
	useClick,
	useHover,
	useDismiss,
	useFocus,
	useDelayGroup,
	safePolygon,
} from '@floating-ui/react'
import {useForm} from '@eitje/form'

export const useInteractions = ({context, config = {}, interactions = [], isNested}) => {
	const {newForm} = useForm()
	const {delay} = useDelayGroup(context, {id: context.floatingId, enabled: !isNested})
	const {click, hover, dismiss, disabled} = config

	// only set enabled false in case disabled is true, otherwise let config decide
	const shouldDisable = disabled ? {enabled: false} : {}
	const clickConfig = {
		ignoreMouse: !!hover?.enabled,
		...click,
		...shouldDisable,
	}

	return useFloatingUiInteractions([
		useClick(context, clickConfig),
		useHover(context, {
			delay: {open: 0, close: 100, ...delay},
			handleClose: safePolygon(),
			...hover,
			...shouldDisable,
		}),
		useFocus(context, {
			enabled: !!newForm,
			...shouldDisable,
		}),
		useDismiss(context, {
			bubbles: isNested,
			...dismiss,
			...shouldDisable,
			outsidePressEvent: 'click',
			referencePressEvent: 'click',
		}),
		...interactions,
	])
}
